import { SUGGEST_INDUSTRY_CATEGORY } from "../configs/routes.js";
import api from "./api.js";

const inFlightByKey = new Map();

function requestKey({ name, description }) {
  return `${name}::${description}`;
}

const suggestIndustryCategory = ({ name, description }) => {
  const trimmedName = String(name ?? "").trim();
  const trimmedDescription = String(description ?? "").trim();
  const key = requestKey({ name: trimmedName, description: trimmedDescription });

  if (inFlightByKey.has(key)) {
    return inFlightByKey.get(key);
  }

  const request = api
    .post(
      SUGGEST_INDUSTRY_CATEGORY,
      { name: trimmedName, description: trimmedDescription },
      { timeout: 60000 }
    )
    .then((response) => response.data)
    .finally(() => {
      inFlightByKey.delete(key);
    });

  inFlightByKey.set(key, request);
  return request;
};

export default suggestIndustryCategory;
